// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const atualizarUsuarioService = async (
  usuarioId: number | undefined | null,
  usuarioData: any
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;
    try {
      const response = await axios.put(URL, usuarioData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
